import { render, staticRenderFns } from "./LeadsHeadline.vue?vue&type=template&id=63c2b179&scoped=true"
import script from "./LeadsHeadline.vue?vue&type=script&lang=ts"
export * from "./LeadsHeadline.vue?vue&type=script&lang=ts"
import style0 from "./LeadsHeadline.vue?vue&type=style&index=0&id=63c2b179&prod&lang=scss&scoped=true"
import style1 from "./LeadsHeadline.vue?vue&type=style&index=1&id=63c2b179&prod&lang=scss"
import style2 from "./LeadsHeadline.vue?vue&type=style&index=2&id=63c2b179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2b179",
  null
  
)

export default component.exports